import Widget from './widget';

require('../scss/app.scss');
window.CookieApprover = new Widget();